// to avoid undefined errors: export upgradeids first

import type { Upgrade } from '../../../types/Upgrade'
import twoExponentRise from './two_exponent_rise'

const upgrades: Upgrade[] = [...twoExponentRise]

export default upgrades
